// config.js
export const ENV = {
	// 开发环境
	development: {
		BASE_URL: 'http://192.168.100.8:8084',
		LOCAL_BASE_URL: 'http://192.168.100.8:8084/',
		CONSOLE_URL: 'http://192.168.100.8/index'
	},

	// 生产环境
	production: {
		BASE_URL: 'http://www.jlsia.com.cn/prod-api',
		LOCAL_BASE_URL: 'http://www.jlsia.com.cn/prod-api/',
		CONSOLE_URL: 'http://www.jlsia.com.cn/sa-manager/index'
	}
};

// 获取当前环境配置
export const getCurrentEnv = () => {
	return process.env.NODE_ENV || 'development';
};

// 获取当前环境的配置
export const getCurrentConfig = () => {
	const env = getCurrentEnv();
	return ENV[env] || ENV.development;
};

// 导出当前环境的配置
export const CURRENT_CONFIG = getCurrentConfig();
